// extracted by mini-css-extract-plugin
export default {"image-drag-zone":"ImageDragZone_image-drag-zone__52FJb","dragging":"ImageDragZone_dragging__IcAxI"};